<template>
 <div class="recruit">
    <div class="video">
      <video poster="@/assets/images/shipin_JPG.png" controls="controls">
        <source src="@/assets/images/demo11.mp4" type="video/mp4">
        <source src="@/assets/images/demo11.webm" type="video/webm">
      </video>
    </div>
    <div class="module show">
      <div class="title">集团风采</div>
      <div class="contentWidth">
        <div class="item w300" @mouseenter="overShow(1)" @mouseleave="overHide($event)">
          <img src="@/assets/images/zjhaopian6_jpg.png"  width="100%"/>
          <p class="title" v-show="show==1">内部酒吧</p>
          <p class="shadow" v-show="show==1"></p>
        </div>
        <div class="item w460" @mouseenter="overShow(2)" @mouseleave="overHide($event)">
          <img src="@/assets/images/zhaopian7_Jpg.png"  width="100%"/>
          <p class="title" v-show="show==2">办公环境</p>
          <p class="shadow" v-show="show==2"></p>
        </div>
        <div class="item w300" @mouseenter="overShow(3)" @mouseleave="overHide($event)">
          <img src="@/assets/images/zhaopian5_jpg.png"  width="100%"/>
          <p class="title" v-show="show==3">公司门头</p>
          <p class="shadow" v-show="show==3"></p>
        </div>
      </div>
      <div class="contentWidth">
        <div class="item w260" @mouseenter="overShow(4)" @mouseleave="overHide($event)">
          <img src="@/assets/images/zhaopian4_jpg.png"  width="100%"/>
          <p class="title" v-show="show==4">豪华年会</p>
          <p class="shadow" v-show="show==4"></p>
        </div>
        <div class="item w260" @mouseenter="overShow(5)" @mouseleave="overHide($event)">
          <img src="@/assets/images/zhaopian3_jpg.png"  width="100%"/>
          <p class="title" v-show="show==5">充电小站</p>
          <p class="shadow" v-show="show==5"></p>
        </div>
        <div class="item w260" @mouseenter="overShow(6)" @mouseleave="overHide($event)">
          <img src="@/assets/images/zhaopian2_jpg.png"  width="100%"/>
          <p class="title" v-show="show==6">休闲区</p>
          <p class="shadow" v-show="show==6"></p>
        </div>
        <div class="item w260" @mouseenter="overShow(7)" @mouseleave="overHide($event)">
          <img src="@/assets/images/zhaopian1_jpg.png"  width="100%"/>
          <p class="title" v-show="show==7">庆祝会</p>
          <p class="shadow" v-show="show==7"></p>
        </div>
      </div>
    </div>
    <div class="module job">
      <div class="title">招聘岗位</div>
      <div class="clearfix jobBox">
        <table class='recruitTable'>
          <thead>
            <tr>
              <th>职位名称</th>
              <th>招聘人数</th>
              <th>薪资范围</th>
              <th>薪资结构</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-for="(info, index) in list" :key=info.id>
            <tr class="hover" v-on:click="foldUpEvent(index)">
              <td>{{ info.postName }}</td>
              <td>{{ info.number }}</td>
              <td>{{ info.salaryRange }}</td>
              <td v-html = "info.salaryStructure.substr(0, 13) + '...'" v-bind:title = info.salaryStructure></td>
              <td class="foldUp"><img v-if="type & showid == index" src="@/assets/images/shouhui_icon.png" alt=""><img v-else src="@/assets/images/zhankai_icon.png" alt=""></td>
            </tr>
            <tr v-show="showid == index">
              <td colspan='2' class="gangwei">
                <p class="label">岗位职责</p>
                <p v-html = "info.duty"></p>
              </td>
              <td colspan='3' class="gangwei">
                <p class="label">任职要求</p>
                <p v-html = "info.requirement"></p>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="module">
      <v-map></v-map>
    </div>
 </div>
</template>

<script>
import map from '@/components/map'
import api from '../config/api'

export default {
  name: 'recruit',
  data () {
    return {
      show: 0,
      showid: '-1',
      type: false,
      list: []
    }
  },
  components: {
    'v-map': map
  },
  methods: {
    overShow (num) {
      this.show = num
    },
    overHide () {
      this.show = 0
    },
    foldUpEvent (index) {
      if (this.showid !== '-1' && this.showid !== index) {
        this.type = false
      }

      if (this.type) {
        this.type = false
        this.showid = '-1'
      } else {
        this.type = true
        this.showid = index
      }
    },
    getRecruit () {
      var params = {
        'startNum': 0,
        'requestNum': 1000
      }
      api.listRecruitRecord(params)
        .then(res => {
          this.submitStatus = false
          if (res.code === 0) {
            this.list = res.list

            console.log(this.list)
          } else {
            this.$emit('tipsShow', '提交失败，请重新填写一遍吧~')
          }
        })
    }
  },
  created () {
    this.getRecruit()
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang='less' scoped>
.recruit{
  .video{
    width: 1100px;
    height: 620px;
    margin: 0 auto;
    video{
      width: 100%;
      height: 100%;
    }
  }
  .module{
    padding: 96px 0 90px 0;
    &>.title{
      text-align: center;
      font-size: 26px;
      color:#333;
      margin-bottom: 52px;
      background: url(../assets/images/line.png) bottom center no-repeat;
      padding-bottom: 22px;
    }
    &.show{
      .item{
        position: relative;
        float: left;
        color: #fff;
        img{display: block;}
        .title{position: absolute;top:0;left: 0;width: 100%;height: 100%;z-index: 2;}
        .shadow{
          position: absolute;top:0;left: 0;width: 100%;height: 100%;
          background-color: #000;
          opacity: 0.3;
          z-index: 1;
        }
      }
      .w300{width: 300px;line-height: 300px;}
      .w460{width:460px;line-height:300px; }
      .w260{width: 260px;line-height: 200px;margin-top: 24px;}
      .contentWidth{
        display: flex;
        align-items: center;
        justify-content: space-between;
        text-align: center;
        flex-wrap: wrap;
      }
    }
    &.job{
      table{
        width:100%;
        text-align:center;
        border-collapse:collapse;
        border-spacing:1;
        border-spacing:0;
        td{
            word-break: break-all;
            word-wrap:break-word;
        }
      }
      background-color: #fff9ef;
      .jobBox{
        margin: 0 auto;
        width: 1040px;
        padding: 42px 30px 66px;
        background: #fff;
        .recruitTable{
          background: #fff;
          text-align: center;
          tr{
            height: 61px;
            line-height: 61px;
            border-bottom: 1px solid #ccc;
            td{
              width: 20%;
            }
            .gangwei{
              text-align: left;
              vertical-align: top;
              padding: 44px 0  44px 82px;
              p{
                line-height: 30px;
              }
              .label{
                font-weight: bold;
              }
            }
          }
          tbody{
            .hover:hover{
              background: #fff9ef;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/recruit.vue